<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="3"></ucMenu>
					<div class="right_con">
						<div class="goods_main">
							<p class="fb">打单发货</p>
							<div class="select_wrap">
								<el-input class="w290 mr" v-model="searchData.order_no" placeholder="请输入订单编号" clearable>
									<p slot="prefix" class="label_title">订单编号</p>
								</el-input>
								<el-date-picker class="mr w290"
									v-model="searchData.search_date"
									type="datetimerange"
									align="right"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd HH:mm:ss"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
								<el-button plain size="small" @click="getList">查询</el-button>
								<el-button plain size="small" @click="resetSearch">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p class="tab" :class="state==0?'active':''" @click="bindSate(0)">待打标签</p>
								<p class="tab" :class="state==1?'active':''" @click="bindSate(1)">待发货</p>
								<p class="tab" :class="state==2?'active':''" @click="bindSate(2)">已发货</p>
							</div>
							<div class="totals_btn">
								<p class="totals">共{{page_data.total}}条</p>
								<!-- <el-button plain size="small" v-if="state==0||state==1||state==2" @click="showPrintBills()">打印进货单</el-button> -->
								<el-button plain size="small" @click="showPrintTags()">打印标签</el-button>
								<el-button plain size="small" v-if="state==1" @click="showAutoDelivery()">打单发货</el-button>
								<!-- <el-button plain size="small" v-if="state==1" @click="showDelivery()">打印面单</el-button> -->
								<!-- <el-button plain size="small">批量发货</el-button> -->
								<!-- <el-button plain size="small">打印面单</el-button> -->
								<!-- <el-button plain size="small" @click="reprintOrder()">补打面单</el-button> -->
							</div>
							<div class="list_title">
								<el-table
										ref="multipleTable"
										:header-row-style="{background:'#f9f9f9', color:'#666', 'line-hight':'50px', 'height': '50px','text-align':'center'}"
								    :data="list"
										@selection-change="selection" row-key="id"
										v-loading="isLoading" 
								    style="width: 100%">
										<el-table-column align="left" type="selection" width="50"></el-table-column>
										<el-table-column
										  prop="scope"
											align="left"
										  label="收货信息"
										  width="">
											<template slot-scope="scope">
												<div class="address-info">
													<p>{{scope.row.order_address.mask_name}}</p>
													<p>{{scope.row.order_address.mask_phone}}</p>
													<p>{{scope.row.order_address.province}}{{scope.row.order_address.city}}{{scope.row.order_address.town}}{{scope.row.order_address.mask_detail}}
													</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column
										  prop="scope"
										  label="订单编号"
										  width="90">
											<template slot-scope="scope">
													{{scope.row.order.dd_order_id}}
											</template>
										</el-table-column>
										<el-table-column
										  prop="scope"
										  label="货品信息"
										  width="250">
											<template slot-scope="scope">
												<div class="product-info" v-for="(product,pidx) in scope.row.supplier_order_product" :key="pidx">
													<!-- <el-checkbox :checked="product.is_select==1" @change="bindOrderProductSelect(product.id,scope.row)" :label="product.id" style="position: absolute;left: 4px;"></el-checkbox> -->
													<div>
														<el-image class="coverimg" fit="contain" :src="product.product_pic">
															<div slot="error" class="image-slot">
																<i class="el-icon-picture-outline"></i>
															</div>
														</el-image>
													</div>
													
													<div class="name-wrap">
														<div class="name" :title="product.product_name">{{product.product_name}}
														</div>
														<div class="attr" :title="product.spec_value">{{product.spec_value}} x {{product.item_num}}</div>
														<div class="winfo" v-if="product.is_exchange==1">换货订单</div>
													</div>
												
												</div>
											</template>
										</el-table-column>
										<el-table-column
										  prop="scope"
										  label="订单状态" width="100">
											<template slot-scope="scope">
												<p class="status">{{scope.row.order.order_status_text}}</p>
												<p class="status" v-if="scope.row.is_cancel != 1">{{scope.row.print_order_id=='0'?'待打单':'已打单'}}</p>
											</template>
										</el-table-column>
										<el-table-column
										  prop="scope."
										  label="其他"
										  width="">
											<template slot-scope="scope">
												<div class="remark">
													<p>买家备注：{{scope.row.order.buyer_words}}</p>
													<p>商家备注：{{scope.row.order.seller_words}}</p>
													<p class="red" v-if="scope.row.print_error">打单错误：{{scope.row.print_error}}</p>
												</div>
											</template>
										</el-table-column>
										<el-table-column
										  prop="order.create_time"
										  label="时间"
										  width="100">
										</el-table-column>
										<el-table-column
										  prop="scope"
										  label="操作"
										  width="90">
											<template slot-scope="scope">
													<el-button type="danger" v-if="scope.row.print_order_id!=0" size="mini" @click="cancelBill(scope.row.id)">取消面单</el-button>
													<el-button type="danger" v-if="scope.row.print_order_id!=0" size="mini" @click="showOrderPrinter(scope.row.id)">打印面单</el-button>
											</template>
										</el-table-column>
								  </el-table>
							</div>
						</div>
						
						<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
					</div>
				</div>
			</div>
		</div>
		<!-- 自动打单发货弹窗 -->
		<el-dialog title="自动打单发货" :visible.sync="dialog.autoDeliverDialog" width="800px" center :close-on-click-modal="false">
			<autoPrintDeliver @close="dialog.autoDeliverDialog = false,getList()" @success="printDeliverSuccess" :isLoading.sync="isLoading" :show.sync="dialog.autoDeliverDialog"></autoPrintDeliver>
		</el-dialog>
		<!-- 选择快递、发货地址弹窗 -->
		<el-dialog :title="'选择发货信息'+(print_order_id.length==0?'【批量打单】':'【批量打单】')" :visible.sync="dialog.deliverDialog" width="30%" center >
			<orderPrintDeliver @close="dialog.deliverDialog = false" @success="printDeliverSuccess" :isLoading.sync="isLoading" :show.sync="dialog.deliverDialog" :order_id.sync="order_id"></orderPrintDeliver>
		</el-dialog>
		<!-- 打印面单弹窗 -->
		<el-dialog title="打印快递面单" :visible.sync="dialog.processDialog" width="400px" center >
			<orderPrintProcess @close="dialog.processDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.processDialog" :print_order_id.sync="print_order_id"></orderPrintProcess>
		</el-dialog>
		<!-- 批量发货弹窗 -->
		<el-dialog title="批量发货" :visible.sync="dialog.batDeliverDialog" width="400px" center >
			<orderBatDeliver @close="dialog.batDeliverDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.batDeliverDialog" :ids.sync="ids"></orderBatDeliver>
		</el-dialog>
		<!-- 打印弹窗 -->
		<el-dialog title="打印订单" :visible.sync="dialog.printDialog" width="400px" center >
			<orderPrinter @close="dialog.printDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.printDialog" :ids.sync="ids"></orderPrinter>
		</el-dialog>
		<!-- 打印进货单弹窗 -->
		<el-dialog title="打印进货单" :visible.sync="dialog.billsDialog" width="400px" center >
			<orderBills @close="dialog.billsDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.billsDialog" :order_id.sync="order_id"></orderBills>
		</el-dialog>
		<!-- 打印标签弹窗 -->
		<el-dialog title="打印标签" :visible.sync="dialog.tagsDialog" width="400px" center >
			<orderTags @close="dialog.tagsDialog = false" @success="getList()" :isLoading.sync="isLoading" :show.sync="dialog.tagsDialog" :order_id.sync="order_id"></orderTags>
		</el-dialog>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import common from '@/assets/js/utils/common.js'
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import orderPrintDeliver from '../../components/orderPrintDeliver/orderPrintDeliver';
import autoPrintDeliver from '../../components/autoPrintDeliver/autoPrintDeliver';
import orderPrintProcess from '../../components/orderPrintProcess/orderPrintProcess';
import orderBatDeliver from '../../components/orderBatDeliver/orderBatDeliver';
import orderPrinter from '../../components/orderPrinter/orderPrinter';
import orderBills from '../../components/orderBills/orderBills';
import orderTags from '../../components/orderTags/orderTags';
export default {
	name: "ucenterDeliver",
	components:{
		myHead,myFoot,ucMenu,Pagination,orderPrintDeliver,orderPrintProcess,orderBatDeliver,orderPrinter,orderBills,orderTags,autoPrintDeliver
	},
	data() {
		return {
			isLoading: false,
			state: 0,
			ids:'',
			list:[],
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			dialog: {
				deliverDialog:false,
				processDialog:false,
				batDeliverDialog:false,
				printDialog:false,
				billsDialog:false,
				tagsDialog:false,
				autoDeliverDialog:false
			},
			searchData:{
				order_no:'',
			},
			order_id:[],
			supplier_order_product_id: [],
			print_order_id:[],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	created() {
		// this.initData()
		this.getList()
	},
	destroyed() {
	},
	methods: {
		...mapActions({
			getSupplierOrderList:"ucenter/getSupplierOrderList",
			opSupplierOrderDeliver:"ucenter/opSupplierOrderDeliver",
			opOrderCancelBill:"ucenter/opOrderCancelBill",
			opSupplierMakeOrderBills:"ucenter/opSupplierMakeOrderBills"
		}),
		
		selection(selection) {
			this.ids = selection.map(item => item.id)
		},
		
		//重置搜索
		resetSearch(){
			this.page_data.page = 1
			this.searchData = {}
			this.getList()
		},
		showOrderPrinter(id){
			this.dialog.printDialog = true
			this.ids = [id]
		},
		//取消面单
		cancelBill(id){
			console.log(id)
			this.$confirm('此操作取消电子面单, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = {id:id}
				this.opOrderCancelBill({data:param,success:(res)=>{
					if(res.code===200){
						this.$message({message: res.msg,type: 'success'})
						this.getList()
					} else {
						this.$message({message: res.msg,type: 'error',});
					}
					this.isLoading = false
				}})
			}).catch(() => {
				this.$message({message: res.msg,type: 'error'})    
			})
		},
		getList(showLoading = true){
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page,state:this.state}
			Object.assign(param, this.searchData)
			// console.log(param)
			this.getSupplierOrderList({data:param,success:(res)=>{
				if(res.code===200){
					this.list = res.data.data
					this.page_data.total = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		//切换状态
		bindSate(e){
			this.state = e
			this.getList()
		},
		showAutoDelivery(){
			this.dialog.autoDeliverDialog = true
		},
		showDelivery(){
			this.order_id = this.ids
			if(this.order_id.length == 0){
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			this.dialog.deliverDialog = true
		},
		showPrintBills(){
			this.order_id = this.ids?this.ids.join(','):''
			this.dialog.billsDialog = true
		},
		showPrintTags(){
			this.order_id = this.ids?this.ids.join(','):''
			this.dialog.tagsDialog = true
		},
		//批量打单成功回调
		printDeliverSuccess(){
			this.getList()
		},
		//补打面单
		reprintOrder(){
			let ids = this.ids
			let list = this.list
			if(ids.length == 0){
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			let print_order_id = []
			for(var i in ids){
				var item = list.find(val => val.id == ids[i])
				print_order_id.push(item.print_order_id)
			}
			this.printDeliverSuccess(print_order_id)
		},
		//批量发货
		batDeliver(){
			let ids = this.ids
			if(ids.length == 0){
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			this.dialog.batDeliverDialog = true
		},
		//打印订单
		print(){
			let ids = this.ids
			if(ids.length == 0){
				this.$message({message: '请勾选订单',type: 'error'})
				return;
			}
			this.dialog.printDialog = true
		},
		//选择订单商品
		// bindOrderProductSelect(id,row){
		// 	let list = this.list
		// 	console.log(id)
		// 	console.log(row)
		// }
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 28px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 500px;}
.right_con{width: 980px;background: #fff;}
.goods_main{padding: 36px 40px 46px;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 10px;}
.select_wrap .w290{width: 290px;margin-top: 14px;position: relative;}
.select_wrap .cate-label{position: absolute;left: 5px;z-index: 1;padding-left: 10px;}
.el-cascader{line-height: 34px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;margin-left: 10px;}
.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;}
.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;}
.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}

.list_title{margin-top: 10px;}
.list_title .status{width: 80px;display: flex;justify-content: flex-start;align-items: center;}
.list_title .status::before{content: '';width: 8px;height: 8px;border-radius: 50%;margin-right: 6px;}
.list_title .status.sales::before{background: #0ea11f;}
.list_title .status.xiajia::before{background: #ccc;}
.list_title .status.fail::before{background: var(--red);}
.list_title .status.fail{color: var(--red);}
.list_title .time{width: 60px;line-height: 16px;margin: 0 20px;}
.list_title .guanlian{color: #1966ff;cursor: pointer;}
.list_title .guanlian:hover{text-decoration: underline;}
.list_title .opts{color: var(--red);cursor: pointer;margin-top: 6px;display:inline-block;margin-right: 10px;}
.list_title .opts.green{color: #0ea11f;}
.list_title .opts:hover{text-decoration: underline;}
.list_title .product-info{display: flex;margin-bottom: 10px;font-size: 12px;line-height: 16px;}
.list_title .product-info .coverimg{width: 50px;height: 50px;border-radius: 5px;background-color: #f0f0f0;}
.list_title .product-info .name-wrap{width: calc(100% - 60px);display: flex;flex-direction: column;margin-left: 10px;text-align: left;}
.list_title .product-info .name-wrap .name{width: 100%;display:-webkit-box;-webkit-box-orient:vertical; -webkit-line-clamp:2; text-overflow:ellipsis;overflow: hidden;position: relative;margin-bottom: 5px;}
.list_title .product-info .name-wrap .name .edit-title{position: absolute;right: 0;top: 22px;}
.list_title .product-info .name-wrap .id{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #999;}
.list_title .product-info .name-wrap .attr{width: 200px;color: #999;}
.list_title .product-info .name-wrap .winfo{color: #ffaa00;}
.header-row{background-color: #f9f9f9;}
.el-table .warning-row {background: oldlace;}
.el-table .success-row {background: #f0f9eb;}


.opts_wrap{padding-top: 14px;}
.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
.opts_line .txt{width: 110px;text-align: right;font-size: 14px;}
.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
.opts_line .con .t{font-size: 14px;color: var(--red);text-decoration: underline;cursor: pointer;}
.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
.ml8{margin-left: 8px;}
.w100{width: 100%;}
.el-input{width: unset !important; }
.address-info{text-align: left;font-size: 12px;}
.remark p{font-size: 12px;line-height: 16px;}
.remark .red{color: var(--red);}
</style>
<style>

.select_wrap .el-button{margin-top: 14px;margin-right:10px;margin-left: 0 !important;}
.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
.mr10{margin-right: 10px;}
/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/ 
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}

.el-table th.el-table__cell{background-color: unset;}
.el-table th.el-table__cell>.cell{padding-left: 14px;padding-right: 14px;}

.el-date-editor .el-range-separator{line-height: 26px;}
.el-date-editor{width:290px !important;height: 34px !important;line-height: 34px !important;font-size: 12px !important;margin-top: 14px;}
.el-range-editor.is-active, .el-range-editor.is-active:hover{border-color: var(--red);}
.el-date-table td.end-date span, .el-date-table td.start-date span{background-color: var(--red);}
.el-date-table td.today span{color: var(--red);}
.el-picker-panel__icon-btn:hover,.el-date-table td span:hover,.el-date-table td div:hover,.el-date-table td.available:hover,.el-picker-panel__shortcut:hover{color: var(--red);}
.el-date-editor .el-range__icon{line-height: 27px;}
</style>
